import React, { useMemo, useState } from 'react';
import { ProjectMetadataContext } from './context';
import { ProjectMetadataContextProviderProps, DefaultMetadata } from './project-metadata-type';
import useFetch from '@/hook/useFetch/useFetch';
import { getMetadataProject } from '@/services/metadata-project/metadata-project';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';

const defaultMetadata = {
    title: 'Myst wallet',
    description: 'Myst wallet',
    keywords: 'Persea, web3, wallet',
    author: 'Persea',
    robots: 'index, follow',
    viewport: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
    themeColor: '#000000',
    favicon: '/favicon.svg',
    appleTouchIcon: '/apple-touch-icon.png',
    msTileImage: '/mstile-150x150.png',
    msTileColor: '#000000',
};

export const ProjectMetadataContextProvider: React.FC<ProjectMetadataContextProviderProps> = ({ children }) => {
    const { data } = useFetch<DefaultMetadata[], object>(getMetadataProject, {}, { autoFetch: false });
    const [metadataState, setMetadataState] = useState<DefaultMetadata>(data?.[0] || defaultMetadata);
    
    const setMetadata = (newMetadata: Partial<DefaultMetadata>) => {
        setMetadataState(currentMetadata => ({
            ...currentMetadata,
            ...Object.fromEntries(
                Object.entries(newMetadata).filter(([_, value]) => value !== undefined)
            )
        } as DefaultMetadata));
    };

    const value = useMemo(() => ({
        metadata: metadataState,
        setMetadata,
    }), [metadataState]);

    return (
        <ProjectMetadataContext.Provider value={value}>
            <SEOHelmet metadata={metadataState} />
            {children}
        </ProjectMetadataContext.Provider>
    );
};
